module.exports = __webpack_public_path__ + "img/aa_pic_logo@2x.30ad9432.png";